export default __webpack_public_path__ + "static/media/12-conduct-an-interview.a6174573.svg";